export const diagnostico = {
  hero: {
    title: "Diagnóstico Estratégico",
    subtitle: "Análise técnica estruturada para decisões patrimoniais via consórcio regulado."
  },
  indicatedFor: {
    title: "Indicado para",
    items: [
      "Aquisição imobiliária com planejamento de médio prazo",
      "Construção ou reforma com estrutura de crédito disciplinada",
      "Planejamento patrimonial com governança técnica",
      "Estruturação empresarial via consórcio regulado",
      "Análise de cartas contempladas para utilização estratégica"
    ]
  },
  whatWillBeDetailed: {
    title: "O que será detalhado",
    items: [
      "Análise do perfil patrimonial e objetivo declarado",
      "Modelagem de cenários (base e stress) conforme regulamento",
      "Estrutura de execução e variáveis operacionais",
      "Acompanhamento técnico até utilização do crédito"
    ]
  },
  howItWorks: {
    title: "Como funciona",
    steps: [
      {
        number: "01",
        title: "Preenchimento",
        description: "Você preenche o formulário com informações patrimoniais e objetivo."
      },
      {
        number: "02",
        title: "Análise Técnica",
        description: "Nossa equipe analisa viabilidade, regulamento e estrutura de execução."
      },
      {
        number: "03",
        title: "Retorno Estruturado",
        description: "Você recebe diagnóstico técnico com cenários modelados e próximos passos."
      }
    ]
  },
  form: {
    title: "Solicitar Diagnóstico",
    fields: {
      name: "Nome completo",
      whatsapp: "WhatsApp",
      email: "E-mail",
      objective: "Objetivo",
      objectiveOptions: {
        placeholder: "Selecione o objetivo",
        acquisition: "Aquisição Imobiliária",
        construction: "Construção/Reforma",
        planning: "Planejamento Patrimonial",
        companies: "Estruturação Empresarial",
        contemplated: "Carta Contemplada"
      },
      assetValue: "Valor do ativo (R$)",
      comfortableInstallment: "Parcela confortável (R$)",
      horizon: "Horizonte (meses)",
      alreadyParticipates: "Já participa de consórcio?",
      hasContemplatedCard: "Possui carta contemplada?",
      yes: "Sim",
      no: "Não"
    },
    button: "Solicitar Diagnóstico Estratégico",
    success: "Diagnóstico solicitado com sucesso. Retornaremos em até 48h úteis.",
    error: "Erro ao enviar. Tente novamente ou entre em contato via WhatsApp."
  },
  governance: {
    title: "Governança",
    text: "A contemplação não pode ser garantida. Não há promessa de rentabilidade fixa. Custos e condições (taxa de administração e fundo de reserva) variam conforme regulamento e administradora. Este diagnóstico é uma análise técnica, não uma promessa de resultado."
  },
  finalCta: {
    title: "Prefere falar diretamente?",
    subtitle: "Nossa equipe está disponível via WhatsApp para esclarecer dúvidas antes do diagnóstico.",
    button: "Falar com Especialista"
  },
  faq: {
    title: "Perguntas Frequentes",
    subtitle: "Dúvidas comuns sobre o processo de diagnóstico e consórcio regulado.",
    items: [
      {
        question: "O que é o Diagnóstico Estratégico da FGT Capital?",
        answer: "É uma análise técnica estruturada do seu perfil patrimonial e objetivo declarado. A partir das informações fornecidas, nossa equipe modela cenários, avalia viabilidade regulatória e propõe uma estrutura de execução adequada — sem promessa de resultado."
      },
      {
        question: "Quanto tempo leva para receber o retorno após o preenchimento?",
        answer: "O retorno é realizado em até 48 horas úteis após o envio do formulário. O contato é feito pelo WhatsApp ou e-mail informados."
      },
      {
        question: "O diagnóstico tem algum custo?",
        answer: "Não. O Diagnóstico Estratégico é gratuito e sem compromisso. Trata-se de uma análise preliminar para verificar aderência entre seu objetivo e as soluções disponíveis."
      },
      {
        question: "A contemplação é garantida?",
        answer: "Não. A contemplação depende do regulamento do grupo, da dinâmica assemblear e de eventuais lances. O diagnóstico estrutura cenários e execução, mas não garante prazo ou resultado."
      },
      {
        question: "Consórcio tem juros?",
        answer: "Não há cobrança de juros. No entanto, incidem taxa de administração e fundo de reserva, cujos percentuais variam conforme o regulamento e a administradora. Esses custos são detalhados durante o diagnóstico."
      },
      {
        question: "Qual é o valor mínimo para participar?",
        answer: "Não há um valor mínimo único — depende do tipo de consórcio, do grupo e do objetivo. Durante o diagnóstico, nossa equipe apresenta as faixas disponíveis compatíveis com seu perfil."
      },
      {
        question: "Posso usar o consórcio para fins empresariais?",
        answer: "Sim. A FGT Capital estrutura operações via consórcio para pessoas jurídicas, incluindo aquisição de ativos, expansão e planejamento patrimonial corporativo. Selecione 'Estruturação Empresarial' no formulário."
      },
      {
        question: "O que é uma carta contemplada?",
        answer: "É uma cota de consórcio já contemplada, disponível para uso imediato do crédito. A FGT Capital realiza curadoria técnica dessas cartas, avaliando regularidade, administradora e condições de transferência antes de qualquer indicação."
      }
    ]
  }
};